"use client";

import { sendPageview } from "@/utils/analytics/send-page-view";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useCookieConsent } from "react-cookie-manager";

export function Analytics() {
	const pathname = usePathname();
	const { detailedConsent } = useCookieConsent();

	useEffect(() => {
		if (detailedConsent?.Analytics?.consented) {
			sendPageview(pathname);
		}
	}, [pathname, detailedConsent]);

	return null;
}
